import useAuth from "@/hooks/useAuth"
import { Navigate, Outlet } from "react-router-dom"
import useGetPermissionRoutesObj from "@/hooks/useGetPermissionRoutesObj";


const AuthOutlet = () => {
    const isAuthenticated = useAuth();  // Ensure this is memoized or stable.
    const { implementedRoutes } = useGetPermissionRoutesObj();  // Ensure stable.
  
    if (isAuthenticated) {
      return <Navigate to={implementedRoutes[0] || "/"} replace />;
    }
    
    return <Outlet/>;
  };
  
  export default AuthOutlet;
  